import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { startNativeBridge } from './lib/nativeBridge';
import { AppProvider } from './state/AppContext';
import './index.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Lexicon: #root element missing');

// Before the first render, so a cold start from a challenge link lands on
// the challenge as early as possible instead of flashing today's puzzle.
// (The launch URL arrives asynchronously; if it resolves after mount the
// router's own subscription picks the navigation up.) A no-op on web.
startNativeBridge();

createRoot(rootEl).render(
  <StrictMode>
    <AppProvider>
      <App />
    </AppProvider>
  </StrictMode>,
);
